<script lang="ts">
  import MainLayout from './MainLayout.svelte'

  let { data, children } = $props()
  let supabase = $derived(data.supabase)
  let session = $derived(data.session)
</script>

<MainLayout {supabase} {session}>
  {@render children?.()}
</MainLayout>
